import { TABS, tabsIndex } from "configs";

export const getCommissionPayer = (feePaidBy: keyof typeof tabsIndex.createEscrowCommissionPayer | undefined) => {
  if (feePaidBy) {
    const index = tabsIndex.createEscrowCommissionPayer[feePaidBy];
    return TABS.createEscrowCommissionPayer[index].title;
  }
  return "";
};
